import React from 'react';

import { ErrorPage } from 'app/ErrorHandling';
import { SubscriptionDetail } from 'features/user_admin/SubscriptionDetail';
import { UserProjectsPanel } from 'features/user_admin/UserProjectsPanel';

import { ProjectDetail } from './ProjectDetail';
import { UserProjectRequestPage } from './UserProjectRequestPage';

export function userAdminRoutes() {
  const routes = [
    {
      path: 'projects',
      element: <UserProjectsPanel />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'projects/:sub_id',
      element: <SubscriptionDetail />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'projects/:sub_id/requests/new',
      element: <UserProjectRequestPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'projects/:sub_id/requests/:upr_id',
      element: <UserProjectRequestPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: 'projects/:sub_id/:project_id',
      element: <ProjectDetail />,
      errorElement: <ErrorPage />,
    },
  ];
  return routes;
}
